import { apiPatch } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { 
  IScoreConversionTable, 
  IUpdateScoreConversionTableRequest 
} from "./types";

/**
 * Score Conversion Table 수정 API 함수
 * @param id Score Conversion Table ID
 * @param data 수정할 데이터
 * @returns API 응답 객체
 */
export const apiUpdateScoreConversionTable = async (
  id: string,
  data: IUpdateScoreConversionTableRequest
) => {
  const response = await apiPatch<IScoreConversionTable>(
    `/score_conversion_tables/${id}`,
    data
  );
  return response.data;
};

/**
 * Score Conversion Table 수정 Mutation Hook
 */
export const useUpdateScoreConversionTableMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { 
      id: string; 
      data: IUpdateScoreConversionTableRequest 
    }) => apiUpdateScoreConversionTable(id, data),
    onSuccess: (data, variables) => {
      // 상세 쿼리 무효화
      queryClient.invalidateQueries({
        queryKey: QueryKeys.scoreConversionTable.detail(variables.id),
      });
      // 목록 쿼리 무효화
      queryClient.invalidateQueries({
        queryKey: QueryKeys.scoreConversionTable.list(),
      });
    },
  });
}; 